import React, { useState, useEffect } from 'react';
import api from '../api';

export default function Subscription() {
  const [plans, setPlans] = useState<any[]>([]);
  const [active, setActive] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({ plan_type: 'monthly', payment_provider: 'manual', payment_reference: '', receipt_url: '' });
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');
  const tenant = JSON.parse(localStorage.getItem('customer_tenant') || '{}');
  const color = tenant.color || '#7C3AED';

  useEffect(() => {
    Promise.all([
      api.get('/api/customer/subscription/plans').catch(() => ({ data: { plans: [] } })),
      api.get('/api/customer/subscription/status').catch(() => ({ data: { active_subscription: null } })),
    ]).then(([plansRes, statusRes]) => {
      setPlans(plansRes.data.plans || []);
      setActive(statusRes.data.active_subscription);
      setLoading(false);
    });
  }, []);

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    const plan = plans.find(p => p.type === form.plan_type) || plans[0];
    if (!plan) return;
    setSaving(true);
    try {
      await api.post('/api/customer/subscription/request', {
        plan_type: form.plan_type,
        payment_provider: form.payment_provider,
        amount: plan.price,
        currency: plan.currency,
        payment_reference: form.payment_reference || null,
        receipt_url: form.receipt_url || null,
      });
      setMsg('✅ Solicitud enviada. El administrador activará tu suscripción al verificar el pago.');
    } catch (err: any) {
      setMsg('❌ ' + (err.response?.data?.error || 'Error'));
    } finally { setSaving(false); }
  };

  if (loading) return <div style={{ padding: '2rem', color: '#888', fontFamily: 'sans-serif' }}>Cargando...</div>;

  return (
    <div style={{ minHeight: '100vh', background: '#0f0f1a', color: '#fff', fontFamily: 'sans-serif', padding: '1.5rem' }}>
      <h2 style={{ margin: '0 0 1.5rem' }}>💳 Suscripción</h2>

      {active ? (
        <div style={{ background: '#064e3b', borderRadius: '12px', padding: '1.5rem', marginBottom: '1.5rem', border: '1px solid #10b981' }}>
          <div style={{ fontWeight: 700, fontSize: '1.1rem', marginBottom: '0.5rem' }}>✅ Suscripción activa</div>
          <div style={{ color: '#6ee7b7' }}>Plan {active.plan_type} · Vence el {new Date(active.ends_at).toLocaleDateString('es-CO')}</div>
        </div>
      ) : (
        <div style={{ background: '#1a1a2e', borderRadius: '12px', padding: '1.5rem', marginBottom: '1.5rem', border: '1px solid #2a2a3e' }}>
          <p style={{ color: '#888', margin: '0 0 1.5rem', fontSize: '0.9rem' }}>Elige un plan para acceder al catálogo completo de karaoke.</p>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', gap: '0.75rem', marginBottom: '1.5rem' }}>
            {plans.map(plan => (
              <div key={plan.type} onClick={() => setForm(f => ({ ...f, plan_type: plan.type }))} style={{ background: form.plan_type === plan.type ? color + '33' : '#0f0f1a', border: `2px solid ${form.plan_type === plan.type ? color : '#333'}`, borderRadius: '10px', padding: '1rem', cursor: 'pointer', textAlign: 'center' }}>
                <div style={{ fontWeight: 700, fontSize: '1.1rem' }}>{plan.name}</div>
                <div style={{ color: color, fontSize: '1.4rem', fontWeight: 900, margin: '0.25rem 0' }}>
                  {plan.currency} {parseInt(plan.price).toLocaleString()}
                </div>
                <div style={{ color: '#888', fontSize: '0.78rem' }}>{plan.description}</div>
              </div>
            ))}
          </div>

          <form onSubmit={handleSubscribe}>
            <div style={{ color: '#888', fontSize: '0.78rem', marginBottom: '0.75rem', textTransform: 'uppercase', letterSpacing: '1px' }}>Método de pago</div>
            <select style={inp} value={form.payment_provider} onChange={e => setForm(f => ({ ...f, payment_provider: e.target.value }))}>
              <option value="manual">Transferencia / Consignación manual</option>
              <option value="epayco">ePayco</option>
              <option value="paypal">PayPal</option>
              <option value="stripe">Stripe</option>
            </select>

            {form.payment_provider === 'manual' && (
              <>
                <p style={{ color: '#888', fontSize: '0.82rem', margin: '0 0 0.75rem' }}>
                  Realiza el pago y adjunta el número de referencia o comprobante.
                </p>
                <input style={inp} placeholder="Número de referencia / transacción" value={form.payment_reference} onChange={e => setForm(f => ({ ...f, payment_reference: e.target.value }))} />
                <input style={inp} placeholder="URL del comprobante (opcional)" value={form.receipt_url} onChange={e => setForm(f => ({ ...f, receipt_url: e.target.value }))} />
              </>
            )}

            {msg && <p style={{ color: msg.startsWith('✅') ? '#10b981' : '#ef4444', fontSize: '0.9rem', margin: '0 0 0.75rem' }}>{msg}</p>}
            <button type="submit" disabled={saving} style={{ width: '100%', padding: '0.85rem', background: color, border: 'none', borderRadius: '8px', color: '#fff', fontWeight: 600, cursor: 'pointer', fontSize: '1rem' }}>
              {saving ? 'Enviando...' : '📩 Solicitar suscripción'}
            </button>
          </form>
        </div>
      )}
    </div>
  );
}

const inp: React.CSSProperties = { width: '100%', padding: '0.75rem 1rem', marginBottom: '0.75rem', background: '#0f0f1a', border: '1px solid #333', borderRadius: '8px', color: '#fff', fontSize: '0.95rem', boxSizing: 'border-box' };
